import { render, staticRenderFns } from "./PopupMenu.vue?vue&type=template&id=e716666e&scoped=true"
import script from "./PopupMenu.vue?vue&type=script&lang=ts"
export * from "./PopupMenu.vue?vue&type=script&lang=ts"
import style0 from "./PopupMenu.vue?vue&type=style&index=0&id=e716666e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e716666e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e716666e')) {
      api.createRecord('e716666e', component.options)
    } else {
      api.reload('e716666e', component.options)
    }
    module.hot.accept("./PopupMenu.vue?vue&type=template&id=e716666e&scoped=true", function () {
      api.rerender('e716666e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/PopupMenu.vue"
export default component.exports